module.exports = __webpack_public_path__ + "static/media/107-box-package-open-outline 1.d2113b64.svg";